<div class="d-flex">
	<div class="display-6 ms-1 mt-2 mb-1">
		<p-skeleton *ngIf="!preApp"></p-skeleton>
		<span *ngIf="preApp">
			{{ preApp.BusinessInformation.MerchantDba || preApp.BusinessInformation.LegalBusinessName }}
		</span>
	</div>
	<div class="ms-auto">
		<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="back()">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'backward']" size="lg" class="ms-1 me-2"></fa-icon>
					Back
				</div>
			</ng-template>
		</p-button>
	</div>
</div>
<p-divider></p-divider>
<div class="card">
	<ng-container *ngIf="preApp">
		<p-timeline [value]="preApp.activityHistory" layout="horizontal" align="top">
			<ng-template pTemplate="content" let-event>
				<small class="p-text-secondary">
					<div>{{ event.user }}</div>
					<div>
						{{ app.moment(event.dateTime).format('L LT') }}
					</div>
				</small>
			</ng-template>
			<ng-template pTemplate="opposite" let-event>
				<div class="d-flex flex-column">
					<div class="display-14">{{ event.newStatus }}</div>
				</div>
			</ng-template>
		</p-timeline>
		<div class="d-flex">
			<span class="p-float-label mt-4">
				<p-dropdown
					#statusValueInput
					[options]="applicationStatusList"
					optionLabel="label"
					optionValue="label"
					name="statusValueInput"
					[(ngModel)]="preApp.status"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					itemSize="30"
					filter="true"
					(onChange)="onStatusChange()"
					(filterBy)="app.keys(applicationStatusList)"
				></p-dropdown>
				<label for="statusValueInput">Status</label>
			</span>
		</div>
		<p-divider></p-divider>
		<iframe [src]="preApp.Entry.ViewLink | safeUrl" style="border: 0; width: 100%" height="2215"></iframe>
	</ng-container>
</div>
<script src="https://www.cognitoforms.com/f/iframe.js"></script>
